/**
 * @module src/components/tabs
 */

/**
 *
 */
import Store from '@/store';
import { Component } from 'vue-property-decorator';

/**
 * component for displaying log history
 * @author Hanzhi Zhou
 * @noInheritDoc
 */
@Component
export default class LogView extends Store {}
